<template>
  <div id="app">
    <router-view />
    <NvxToast
      :toasts="notificationsStore.toasts"
      @dismiss="notificationsStore.removeToast"
    />
  </div>
</template>

<script setup lang="ts">
import { NvxToast } from '@noovox/design-system'
import { useNotificationsStore } from './stores/notifications'
import { useIdleTimeout } from './composables/useIdleTimeout'

const notificationsStore = useNotificationsStore()

useIdleTimeout()
</script>

<style>
#app {
  min-height: 100vh;
  background-color: var(--nvx-color-background-primary);
  color: var(--nvx-color-text-primary);
}
</style>
